import { ToastContainer } from 'react-toastify'

type PortalToastContainerProps = {
  topOffset?: number
}

export const PortalToastContainer = ({ topOffset = 80 }: PortalToastContainerProps) => (
  <ToastContainer
    position="top-right"
    autoClose={2000}
    hideProgressBar
    newestOnTop
    closeOnClick
    pauseOnHover={false}
    theme={'colored'}
    style={{ position: 'absolute', top: topOffset, width: '100%', maxWidth: 360 }}
    toastStyle={{ borderRadius: 12, fontSize: 13, minHeight: 48 }}
  />
)
